var map = {
	"./50-beaches.mp4": 750,
	"./easy.mp4": 266,
	"./featured-video.mp4": 547,
	"./it-takes-an-island.mp4": 908,
	"./make-it-zero.mp4": 566,
	"./video.mp4": 947
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 366;